import { useState, useEffect } from "react";
import {
  FaCheck,
  FaUnlock,
  FaBolt,
  FaShieldAlt,
  FaHeadset,
} from "react-icons/fa";

export function ThanksPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [showRealThanks, setShowRealThanks] = useState(false);

  useEffect(() => {
    // Parse the URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const srrcParam = queryParams.get("srrc");

    // Check if srrc equals 'abcdef'
    if (srrcParam === "eml998877") {
      setShowRealThanks(true);
    }

    // Simulate loading for parameter validation
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  if (isLoading) {
    return (
      <div className="bg-[#121212] text-white min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 border-4 border-[#fb923c] border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-[#cccccc]">Cargando...</p>
        </div>
      </div>
    );
  }

  return showRealThanks ? <RealThanks /> : <Honeypot />;
}

function Honeypot() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 300);
  }, []);

  return (
    <div className="bg-[#121212] text-white min-h-screen">
      {/* Barra de gradiente */}
      <div className="h-1 bg-gradient-to-r from-[#8a3ab9] via-[#e95950] to-[#fccc63]"></div>

      <div className="max-w-md mx-auto px-5 py-6">
        <div
          className={`bg-[#1e1e1e] rounded-2xl p-6 md:p-8 mb-6 shadow-lg transform transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
        >
          <div className="w-20 h-20 bg-[#fb923c] rounded-full flex items-center justify-center mx-auto mb-5 animate-pulse">
            <FaCheck className="text-white text-3xl" />
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">
            ¡Gracias por tu compra!
          </h1>
          <p className="text-[#fb923c] text-center mb-8 text-sm">
            Tu acceso al informe de análisis de Instagram está en camino
          </p>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaUnlock className="text-[#fb923c] mr-2" /> Información
              importante
            </h3>
            <p className="text-sm text-[#cccccc]">
              Hemos enviado un correo electrónico a la dirección que
              proporcionaste durante la compra. En los próximos segundos
              recibirás el acceso completo al analytics del Instagram.
            </p>
          </div>

          <div className="bg-gradient-to-r from-[#7e22ce20] to-[#db277420] border border-[#7e22ce] rounded-xl p-4 mb-5">
            <h3 className="font-bold flex items-center mb-2">
              <FaBolt className="text-[#fb923c] mr-2" />{" "}
              <p className="text-md text-[#ff0000]">SIGUIENTE PASO</p>
            </h3>
            <p className="text-sm text-[#cccccc] mb-3">
              Por favor, revisa tu bandeja de entrada y también la carpeta de
              spam. Si no encuentras el correo dentro de los próximos 5 minutos,
              contáctanos inmediatamente.
            </p>
            <p className="text-base text-[#fb923c] text-center font-medium">
              El acceso se enviará al email utilizado durante tu compra
            </p>
          </div>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaShieldAlt className="text-[#fb923c] mr-2" /> Tu privacidad está
              protegida
            </h3>
            <p className="text-sm text-[#cccccc]">
              Tu compra y todas las actividades relacionadas con el análisis son
              completamente anónimas. Nadie sabrá que has accedido a esta
              información.
            </p>
          </div>
        </div>

        <div className="bg-[#262626] rounded-xl p-4 mb-6 border border-[#333]">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-[#22c55e] rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">
              Soporte en vivo disponible
            </span>
          </div>
          <p className="text-center text-xs text-[#aaa]">
            Nuestro equipo está en línea 24/7 para ayudarte con cualquier
            pregunta
          </p>
        </div>

        <div className="text-center mt-8 text-[#777] text-xs">
          <p>© 2025 TeaGram. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
}

function RealThanks() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animación simple para mejorar la experiencia del usuario
    setTimeout(() => {
      setIsVisible(true);
    }, 300);
  }, []);

  return (
    <div className="bg-[#121212] text-white min-h-screen ">
      {/* Barra de gradiente */}
      <div className="h-1 bg-gradient-to-r from-[#8a3ab9] via-[#e95950] to-[#fccc63]"></div>

      <div className="max-w-md mx-auto px-5 py-6">
        <div
          className={`bg-[#1e1e1e] rounded-2xl p-6 md:p-8 mb-6 shadow-lg transform transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
        >
          <div className="w-20 h-20 bg-[#fb923c] rounded-full flex items-center justify-center mx-auto mb-5 animate-pulse">
            <FaCheck className="text-white text-3xl" />
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">
            ¡Gracias por tu compra!
          </h1>
          <p className="text-[#fb923c] text-center mb-8 text-sm">
            Tu acceso al informe completo está listo
          </p>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaUnlock className="text-[#fb923c] mr-2" /> Detalles de tu acceso
            </h3>
            <p className="text-sm text-[#cccccc]">
              Tu pago ha sido procesado exitosamente y tu cuenta ha sido
              activada instantáneamente. Ahora tienes acceso de por vida al
              informe completo del perfil.
            </p>
          </div>

          <div className="bg-gradient-to-r from-[#7e22ce20] to-[#db277420] border border-[#7e22ce] rounded-xl p-4 mb-5">
            <h3 className="font-bold flex items-center mb-2">
              <FaBolt className="text-[#fb923c] mr-2" />{" "}
              <p className="text-md text-[#ff0000]">IMPORTANTE</p>
            </h3>
            <p className="text-sm text-[#cccccc]">
              Tu informe básico de análisis del perfil ya está listo.
            </p>
            <a
              href="/delivery.html"
              className="block w-full py-3 px-4 mt-3 bg-[#fb923c]/90 hover:bg-[#f97316] text-white font-bold text-center rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-[#fb923c] focus:ring-opacity-50"
              aria-label="Acceder a tu informe básico ahora"
            >
              ACCEDER A TU INFORME AHORA
            </a>

            <p className="text-base text-red-400 mt-2 text-center">
              El informe puede actualizarse con nueva información a medida que
              nuestros robots AI sigan rastreando y haciendo verificaciones
              automáticas cada 24 horas.
            </p>
          </div>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaShieldAlt className="text-[#fb923c] mr-2" /> Tu privacidad está
              protegida
            </h3>
            <p className="text-sm text-[#cccccc]">
              Tu compra y todas las actividades del perfil son completamente
              anónimas. El perfil objetivo nunca sabrá que está siendo
              monitoreado.
            </p>
          </div>
        </div>

        <div className="bg-[#262626] rounded-xl p-4 mb-6 border border-[#333]">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-[#22c55e] rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">
              Soporte en vivo disponible
            </span>
          </div>
          <p className="text-center text-xs text-[#aaa]">
            Nuestro equipo está en línea 24/7 para ayudarte con cualquier
            pregunta
          </p>
        </div>

        <div className="text-center mt-10">
          <p className="text-sm">El cargo aparecerá como Digistore24.com</p>
        </div>

        <div className="text-center mt-8 text-[#777] text-xs">
          <p>© 2025 TeaGram. Todos los derechos reservados.</p>
          <p className="mt-2">
            Esta compra aparecerá como "Servicios en línea" en tu extracto
            bancario por privacidad.
          </p>
        </div>
      </div>

      {/* Botón flotante de soporte */}
      <a
        href="mailto:teagram.app@proton.me"
        className="fixed bottom-6 right-6 bg-[#fb923c] hover:bg-[#f97316] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Soporte"
      >
        <FaHeadset className="text-xl" />
      </a>

      {/* Información adicional sobre reembolsos */}
      <div className="max-w-md mx-auto px-5 mb-10">
        <div className="bg-[#262626] rounded-xl p-4 mt-6 border border-[#333]">
          <h3 className="text-base font-semibold mb-2">
            Información sobre reembolsos
          </h3>
          <p className="text-sm text-[#cccccc]">
            Para cualquier duda o solicitud de reembolso, debes enviar un correo
            a{" "}
            <a href="mailto:teagram.app@proton.me" className="text-[#fb923c]">
              teagram.app@proton.me
            </a>{" "}
            con los detalles del motivo del reembolso.
          </p>
          <p className="text-sm text-[#cccccc] mt-2">
            Como el entregable es online y no tangible, nuestro equipo analizará
            tu solicitud y te enviará una respuesta en un plazo máximo de 72
            horas.
          </p>
        </div>
      </div>
    </div>
  );
}
